export class UserRole {
    roleCode: string;
    roleName: string;
    sendNotification:string;
    
    constructor() {
    }
    
}